var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[(_vm.notif)?_c('v-alert',{staticClass:"ma-6",attrs:{"prominent":"","type":_vm.notif.type,"dismissible":""},on:{"input":_vm.clearNotif}},[_vm._v(" "+_vm._s(_vm.notif.message)+" ")]):_vm._e(),_c(_vm.currentView,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }